import { EntityType } from "@mapmycustomers/shared/enum";

const TIMEZONE_ENTITIES: Set<EntityType> = new Set([EntityType.ACTIVITY]);

export default TIMEZONE_ENTITIES;
